<template>
  <modal
    elem-id="modal_so_stock_movements"
    :show="isVisible"
    :title="t('Histórico de Movimentações')"
    size="large"
    :close-label="t('Fechar')"
    :save-fn="null"
    @close="handleClose"
    @dismiss="handleClose"
  >
    <template v-if="isVisible && currentProductId">
      <SOStockMovementsTable :productId="currentProductId" />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOStockMovementsTable from './SOStockMovementsTable.vue';
import { log } from '../../utils/DebugLogger';

type Id = number | string;

interface ModalOpenPayload {
  productId?: Id;
}

// Get i18n composable
const { t } = useI18n();

// Reactive data
const isVisible = ref<boolean>(false);
const currentProductId = ref<Id | null>(null);

// Methods
const openModal = (data?: ModalOpenPayload): void => {
  log('SOStockMovementsModal', 'openModal', 'Opening movements modal', data);
  currentProductId.value = data?.productId ?? null;
  isVisible.value = true;
};

const handleClose = (): void => {
  log('SOStockMovementsModal', 'handleClose', 'Closing modal');
  isVisible.value = false;
  currentProductId.value = null;
};

// Lifecycle - Event listeners
onMounted(() => {
  log('SOStockMovementsModal', 'onMounted', 'Component mounted, setting up event listeners');
  eventBus.on('modal.so-stock-movements.open', openModal);
  eventBus.on('modal.so-stock-movements.close', handleClose);
});

onBeforeUnmount(() => {
  log('SOStockMovementsModal', 'onBeforeUnmount', 'Component unmounting, cleaning up event listeners');
  eventBus.off('modal.so-stock-movements.open', openModal);
  eventBus.off('modal.so-stock-movements.close', handleClose);
});

// Expose methods for parent components
defineExpose({
  openModal
});
</script>

<style scoped>
</style>
